"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const SampleList_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SampleList.vue"));
const SamplesZero_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SamplesZero.vue"));
const SamplesLarge_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/SamplesLarge.vue"));
const Heatmap_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Heatmap"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const debounce_1 = require("@common/tsutils/debounce");
const lucide_vue_next_1 = require("lucide-vue-next");
let SelectionArea = class SelectionArea extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.search = '';
        this.forceList = false;
    }
    get selStatus() {
        if (!this.heatmap.selectedSamples.length)
            return 'zero';
        if (this.heatmap.selectedSamples.length > Heatmap_1.default.SEL_MAX_SAMPLES && !this.forceList)
            return 'large';
        return 'list';
    }
    get selListStatus() {
        if (!this.heatmap.filtered_selection)
            return 'loading';
        return 'list';
    }
    get num_selected_samples() {
        if (!this.heatmap.filtered_selection)
            return '...';
        const total = this.heatmap.selectedSamples.length;
        const filtered = this.heatmap.filteredSelectedSamples.length;
        if (total === filtered) {
            return total;
        }
        else {
            return `${filtered}/${total}`;
        }
    }
    undoLastAddition() {
        this.heatmap.undoLastAdd();
    }
    clearAll() {
        this.heatmap.rmAll();
    }
    forceTheList() {
        this.forceList = true;
    }
    clearSearch() {
        this.search = "";
    }
    onSearch() {
        this.onSearch2();
    }
    onSearch2() {
        this.heatmap.filterSelectionText(this.search);
    }
    onAddSamples() {
        if (!this.heatmap.lastSamples.length)
            return;
        this.search = '';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], SelectionArea.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('search')
], SelectionArea.prototype, "onSearch", null);
__decorate([
    (0, debounce_1.Debounce)(500)
], SelectionArea.prototype, "onSearch2", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.lastSamples')
], SelectionArea.prototype, "onAddSamples", null);
SelectionArea = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SampleList: SampleList_vue_1.default,
            SamplesZero: SamplesZero_vue_1.default,
            SamplesLarge: SamplesLarge_vue_1.default,
            Loader: Loader_vue_1.default,
            X: lucide_vue_next_1.X
        }
    })
], SelectionArea);
exports.default = SelectionArea;
